import React, { useCallback } from 'react';

import { titleCase } from '../utils';
import { isOpen } from '../utils/sopUtils';

import { loaders } from '../utils/loaders';

import { Link, useParams } from 'react-router-dom';
import { FaCheck, FaTimes } from 'react-icons/fa';
import Loading from '../components/Loading.jsx';
import SopButton from '../components/SopButton.jsx';
import HomeNav from '../components/HomeNav.jsx';
import SopEmailListSender from '../components/SopEmailListSender.jsx';

const SopList = () => {
    const params = useParams();
    const [inProgress, setInProgress] = React.useState(true);
    const [subs, setSubs] = React.useState({});

    const loadList = useCallback(async (type) => {
        setSubs({});
        setInProgress(true);

        let resp = await loaders.sop_list.load(type);
        let subs = {};
        resp.forEach((sub) => {
            if (!subs[sub.contact.email]) {
                subs[sub.contact.email] = sub.contact;
                subs[sub.contact.email].subs = [];
            }
            subs[sub.contact.email].subs.push(sub);
        });
        setSubs(subs);
        setInProgress(false);
    }, []);

    React.useEffect(() => {
        if (params.freq_type) {
            loadList(params.freq_type);
        }
    }, [params.freq_type, loadList]);

    return (
        <div>
            <HomeNav />

            <div className="container">
                <h2>
                    SOP {params.freq_type === 'rb-quarterly' ? 'Recorded Books Quarterly' : titleCase(params.freq_type)}
                </h2>

                <SopEmailListSender frequency={params.freq_type} />

                {inProgress && <Loading />}
                {!inProgress && (
                    <table className="rwd-table">
                        <thead>
                            <tr>
                                <th>Email</th>
                                <th>Subscriptions</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!Object.keys(subs).length && (
                                <tr>
                                    <td colSpan={3}>No Subscriptions Found.</td>
                                </tr>
                            )}

                            {Object.keys(subs).map((email) => {
                                let user = subs[email];
                                return (
                                    <tr key={email} className="js-customer">
                                        <td data-th="Name">
                                            <span>
                                                <Link to={`/search/${user.email}`}>{user.email}</Link>
                                            </span>
                                        </td>
                                        <td data-th="Subscriptions">
                                            <ul className="list-flat">
                                                {user.subs.map((sub) => {
                                                    sub.is_submitted = false;
                                                    let icon = isOpen(sub) ? <FaTimes /> : <FaCheck />;
                                                    return (
                                                        <li key={`${email}_${sub.internal_id}`}>
                                                            {icon} {sub.description} [#{sub.internal_id}]
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </td>
                                        <td data-th="Actions">
                                            <span>
                                                <SopButton type="trigger" user={user} freq={params.freq_type}>
                                                    Send Trigger
                                                </SopButton>{' '}
                                                <SopButton type="reminder" user={user} freq={params.freq_type}>
                                                    Send Reminder
                                                </SopButton>
                                            </span>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};
export default SopList;
